export enum GtmEvent {
  RegisterWorkshop = 'RegisterWorkshop',
  StartARoom = 'StartARoom',
  SignUp = 'SignUp',
  SignUpPage = 'SignUpPage',
  SignedUpAndSubscribed = 'SignedUpAndSubscribed',
  DownloadApp = 'DownloadApp',
}
